import { createSelector } from "reselect";
import { isPccSelector } from "../../../config_selectors";

export const woundsExportPdfEnabledSelector = createSelector(
  isPccSelector,
  isPCC => {
    return isPCC === false;
  }
);
